import { Link } from '@mui/material';
import { useRouter } from 'next/router';

import ThemeProvider from '@toolbox/style/theme/common/ThemeProvider';
import { getStringParams, populateLinkSearchParams } from '@widget/utils/storyblok';
import { StyledImg, Wrap } from './styles';
import { Icon } from '@widget/toolbox/components';

import type { CardSchema } from '@widget/storyblok/schemas';
import type { z } from 'zod';

type CardProps = z.infer<typeof CardSchema>;
export const CardComponent = ({ asset, ctaLink, passQueryParams }: CardProps) => {
  const router = useRouter();

  const ctaLinkPopulated =
    ctaLink && passQueryParams
      ? populateLinkSearchParams({
          link: {
            url: ctaLink,
            cached_url: ctaLink,
          },
          source: router.query,
          params: getStringParams(passQueryParams),
        }).url
      : ctaLink;

  return (
    <ThemeProvider>
      <Link href={ctaLinkPopulated || ''} target="_blank">
        <Wrap>
          {!!asset?.filename && <StyledImg src={asset?.filename} alt={asset?.alt || ''} />}
          <Icon type="OpenInNewFilled" />
        </Wrap>
      </Link>
    </ThemeProvider>
  );
};
